module.exports = __webpack_public_path__ + "static/media/lock.7d4b6ce3.svg";